import {
    ComponentsOverrides,
    ComponentsProps,
    ComponentsVariants,
    Theme,
} from '@mui/material';

interface M3Link {
    MuiLink: {
        defaultProps?: ComponentsProps['MuiLink'];
        styleOverrides?: ComponentsOverrides<Theme>['MuiLink'];
        variants?: ComponentsVariants['MuiLink'];
    };
}

export const getLink = (theme: Theme): M3Link => {
    return {
        MuiLink: {
            defaultProps: {
                underline: 'hover',
                variant: 'bodyLarge',
                onClick: event => {
                    event.stopPropagation();
                },
            },
            styleOverrides: {
                root: {
                    fontWeight: 600,
                },
            },
        },
    };
};
